/* eslint-disable arrow-body-style */
import http from '@/utils/http';

import { MOCK_GAMES } from '../constants';

import type {
  IGame,
  IFetchGamesParams,
  IFetchCOSInfoResData,
  IFetchVideosParams,
  IFetchVideosResData,
  IDoUploadParams,
  IDeleteVideoParams,
} from '../types';

// 获取COS相关配置，及即将上传的视频的uuid、上传路径
export const fetchCOSInfo = async (): Promise<IFetchCOSInfoResData> => {
  return http({
    method: 'GET',
    url: '/api/v1/aigc/tencent_qcloud/auth',
  }) as Promise<IFetchCOSInfoResData>;
};

// 获取视频信息列表
export const fetchVideos = async (params: IFetchVideosParams): Promise<IFetchVideosResData> => {
  return http({
    method: 'POST',
    url: '/api/v1/aigc/motion/video_info',
    data: params,
  }) as Promise<IFetchVideosResData>;
};

// 上传视频到腾讯云后，同时需要上传视频信息到后端
export const doUpload = (params: IDoUploadParams): Promise<any> => {
  return http({
    method: 'PUT',
    url: '/api/v1/aigc/motion/upload',
    data: params,
  }) as Promise<any>;
};

// 删除视频信息
export const deleteVideo = (params: IDeleteVideoParams): Promise<any> => {
  return http({
    method: 'DELETE',
    url: '/api/v1/aigc/motion/delete',
    data: params,
  }) as Promise<any>;
};

export const fetchGames = async (params: IFetchGamesParams): Promise<IGame[]> => {
  console.log('params of fetchGames: ', params);
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(MOCK_GAMES);
    }, 600);
  });
};
